module.exports = __webpack_public_path__ + "img/dubai-banner.93a7de21.png";